import { render, staticRenderFns } from "./PasswordResetStepCard.vue?vue&type=template&id=b242c474&lang=pug"
import script from "./PasswordResetStepCard.vue?vue&type=script&lang=js"
export * from "./PasswordResetStepCard.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetStepCard.vue?vue&type=style&index=0&id=b242c474&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports